export default __webpack_public_path__ + "static/media/msf_background_m2.7da1a2ce.jpg";